import React from 'react';
import { SettingsLayout } from '../../../design-system/components/layouts';
import {
  PageHeader,
  Input,
  Checkbox,
  FormSection,
  FormActions,
} from '../../../design-system/components';
import { useInertiaForm } from '../../../design-system/hooks';
import {
  admin_settings_application_questions_path,
  admin_settings_application_question_path,
} from '../../../lib/routes';
function QuestionForm({ question, isEdit }) {
  const form = useInertiaForm({
    application_question: {
      question_text: question.question_text || '',
      required: question.required ?? true,
      active: question.active ?? true,
      position: question.position ?? 0,
    },
  });
  const q = form.data.application_question;
  const fieldErrors = form.errors;
  function setField(key, value) {
    form.setData('application_question', {
      ...q,
      [key]: value,
    });
  }
  function handleSubmit(e) {
    e.preventDefault();
    if (isEdit) {
      form.patch(admin_settings_application_question_path(question.id));
    } else {
      form.post(admin_settings_application_questions_path());
    }
  }
  return (
    <SettingsLayout>
      <PageHeader
        title={isEdit ? 'Edit Question' : 'New Question'}
        description={
          isEdit
            ? 'Update this application question'
            : 'Add a new question to the affiliate application form'
        }
      />

      <form onSubmit={handleSubmit} className="mt-6">
        <FormSection heading="Question Details">
          <div className="space-y-4">
            <Input
              label="Question Text"
              value={q.question_text}
              onChange={(e) => setField('question_text', e.target.value)}
              error={fieldErrors.question_text}
              placeholder="e.g. How do you plan to promote our product?"
            />
            <Input
              label="Position"
              type="number"
              value={String(q.position)}
              onChange={(e) => setField('position', parseInt(e.target.value, 10) || 0)}
              error={fieldErrors.position}
              helperText="Determines the display order (lower numbers appear first)"
            />
            <Checkbox
              label="Required"
              description="Applicants must answer this question"
              checked={q.required}
              onChange={(e) => setField('required', e.target.checked)}
            />
            <Checkbox
              label="Active"
              description="Only active questions appear on the application form"
              checked={q.active}
              onChange={(e) => setField('active', e.target.checked)}
            />
          </div>
        </FormSection>

        <FormActions
          submitLabel={isEdit ? 'Update Question' : 'Create Question'}
          processing={form.processing}
          cancelHref={admin_settings_application_questions_path()}
        />
      </form>
    </SettingsLayout>
  );
}
export function NewQuestion({ question }) {
  return <QuestionForm question={question} isEdit={false} />;
}
export function EditQuestion({ question }) {
  return <QuestionForm question={question} isEdit={true} />;
}
